import { render, staticRenderFns } from "./platforms.vue?vue&type=template&id=078d807e&scoped=true"
import script from "./platforms.vue?vue&type=script&lang=ts"
export * from "./platforms.vue?vue&type=script&lang=ts"
import style0 from "./platforms.vue?vue&type=style&index=0&id=078d807e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d807e",
  null
  
)

export default component.exports